import React from 'react';

import cn from 'classnames';

import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { useGenerateMeasurementModal } from '@features/GenerateMeasurement/lib/hooks/useGenerateMeasurementModal';
import { DnDImageList } from '@features/GenerateMeasurement/ui/DnDImageList';
import { CustomModal, DnD, UiButton, Icon, UITooltip, Flex, Input } from '@shared/ui';

import cls from './GenerateMeasurementModal.module.css';

interface GenerateMeasurementModalProps {
    classes?: string;
    isOpenModal: boolean;
    onHideModal?: () => void;
    onGenerateMeasurement: (attachment: TAttachmentOnClient, height: string) => Promise<void>;
}

export const GenerateMeasurementModal = ({
    classes,
    isOpenModal,
    onHideModal,
    onGenerateMeasurement,
}: GenerateMeasurementModalProps) => {
    const { t, form, uploadFilesHandler, fileInputRef, onClickInputRef, error, onInput } =
        useGenerateMeasurementModal();

    return (
        <CustomModal
            isOpen={isOpenModal}
            contentClasses={cn(cls.GenerateMeasurementModal, [classes])}
            onHideModal={onHideModal}
        >
            <CustomModal.Header>
                <Flex direction="row" align="center" justify="center" gap={8}>
                    {t('GenerateMeasurementModal.return.CustomModal.Header')}
                    <Icon iconName="aiStars" />
                    <UITooltip
                        classes={cls.iconWrapper}
                        tooltipClasses={cls.tooltip}
                        label={t(`GenerateMeasurementModal.CustomModal.Header.UITooltip.label`)}
                    >
                        <span className={cls.question}>
                            <Icon iconName="question" fill="currentColor" />
                        </span>
                    </UITooltip>
                </Flex>
            </CustomModal.Header>
            <CustomModal.Body>
                <DnD<TAttachmentOnClient | TAttachmentDTOCamelCased>
                    attachmentsData={form.attachment}
                    multiple={false}
                    error={error}
                    onUploadHandler={uploadFilesHandler}
                    fileInputRef={fileInputRef}
                    containerClassName={cls.dnd}
                    addFileTitle={t(
                        'GenerateMeasurementModal.return.CustomModal.Body.DnD.addFileTitle'
                    )}
                    accept=".png, .jpeg, .gif, .jpg, .webp"
                    renderAttachmentsList={() => (
                        <DnDImageList onClickInputRef={onClickInputRef} file={form.attachment[0]} />
                    )}
                    inputIcon={<Icon iconName="imgInput" />}
                />
                <Input
                    value={form.height}
                    onValueChange={onInput}
                    classes={[cls.input]}
                    label={t('GenerateMeasurementModal.return.CustomModal.Body.Input.label')}
                    placeholder="3,0"
                />
            </CustomModal.Body>
            <CustomModal.Footer>
                <UiButton
                    disabled={form.attachment.length === 0}
                    onClick={() => onGenerateMeasurement(form.attachment[0], form.height)}
                    btnText={t(
                        'GenerateMeasurementModal.return.CustomModal.Footer.UiButton.btnText'
                    )}
                />
            </CustomModal.Footer>
        </CustomModal>
    );
};
